import React from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { colors } from '../../shared/theme/colors';
import { spacing } from '../../shared/theme/spacing';
import { typography } from '../../shared/theme/typography';
import { ComboComponentsEditor } from './ComboComponentsEditor';
import { CatalogProductComboPanel } from './CatalogProductComboPanel';
import { useComboProductPickOptions } from '../hooks/useComboProductPickOptions';
import type { ComboDraftComponent } from '../domain/productCombos';

type Props = {
  mode: 'create' | 'edit';
  organizationId: string | null;
  productId: string;
  productName: string;
  canEdit: boolean;
  salePrice: number;
  formatMoney: (value: number) => string;
  draftComponents: ComboDraftComponent[];
  onDraftChange: (next: ComboDraftComponent[]) => void;
  onSaved?: () => void;
};

export function CatalogProductFormCompositionFields({
  mode,
  organizationId,
  productId,
  productName,
  canEdit,
  salePrice,
  formatMoney,
  draftComponents,
  onDraftChange,
  onSaved,
}: Props) {
  const picksEnabled = mode === 'create' && canEdit;
  const { options, loading } = useComboProductPickOptions(picksEnabled, organizationId);

  if (mode === 'edit') {
    return (
      <CatalogProductComboPanel
        productId={productId}
        productName={productName}
        canEdit={canEdit}
        salePrice={salePrice}
        formatMoney={formatMoney}
        onSaved={onSaved}
      />
    );
  }

  return (
    <View style={styles.wrap}>
      <Text style={styles.lead}>
        Opcional. Buscá productos abajo; al vender, el stock baja en las partes (no en el combo).
      </Text>
      {loading ? (
        <ActivityIndicator color={colors.accent} style={styles.loader} />
      ) : (
        <ComboComponentsEditor
          components={draftComponents}
          productOptions={options}
          onChange={onDraftChange}
          disabled={!canEdit}
        />
      )}
      {!canEdit ? (
        <Text style={styles.muted}>Necesitás permiso de edición en Opciones de menú para armar combos.</Text>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { gap: spacing.sm },
  lead: {
    ...typography.body,
    color: colors.textMuted,
  },
  muted: {
    ...typography.caption,
    color: colors.textMuted,
  },
  loader: { marginVertical: spacing.md },
});
